<script>
	import { getText } from '../../../../share/utils';
</script>

<div class="page-menschen_bewegen-idee marginbox">
	<div class="flex structure">
		<div class="flex row structure-1">
			<div class="flex element">
				<img loading="lazy" alt="Menschen bewegen - Desktops - Ad-Design" src="./../img/12.Menschen_Bewegen/04.programmierung/desktops.webp">
			</div>
		</div>
		
		<div class="flex col structure-2">
			<div class="flex element">
				<img loading="lazy" alt="Menschen bewegen - Desktop - Ad-Design" src="./../img/12.Menschen_Bewegen/04.programmierung/desktop.webp">
			</div>
			
			<div class="flex element">
				<div class="text">
					<h2 class="caption">{getText("12.04.01_h2")}</h2>
					<p class="caption">{getText("12.04.02_caption")}</p>
					<p class="caption blue">Project Lead: Burg Eins & <a href="//thesocialchain.ag" target="_blank">SocialChain (Berlin)</a></p>
				</div>
			</div>
		</div>
	</div>
	
	<div class="img-single">
		<img loading="lazy" alt="Menschen bewegen - Result - Ad-Design" src="./../img/12.Menschen_Bewegen/04.programmierung/result.webp">
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: 0 0 $spacing-mobile 0;
	}
	
	.page-menschen_bewegen-idee {
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: fit-content;
			line-height: 0;
		}
		
		.content {
			flex: 1 100%;
		}

		.structure {
			flex-flow: row wrap;
			margin: $spacing-mobile 0 0 0;
		}
		
		.structure-1 {
			width: 100%;
			padding: 0;
			
			@include for-tablet-portrait-up {
				width: 60%;
				padding-right: $media-gap;
			}
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-2 {
			width: 100%;
			margin-bottom: $media-gap;
			padding: 0;
			
			@include for-tablet-portrait-up {
				width: 40%;
			}
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.text {
			margin: 0;
		}
	}
	
	video {
		width: 100%;
	}
</style>
